<!--
 * @Description: 工程交底审核
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-23 11:21:26
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" disabled placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div class="dialoginfo" style="margin-top: 10px">
              <div class="dialoginfo-title">
                <div :class="type == 0 ? 'active' : 'none'" @click="type = 0">
                  <div>销售信息</div>
                </div>
                <!-- <div v-if="caiwu" :class="type == 1 ? 'active' : 'none'" @click="type = 1">
                  <div>财务信息</div>
                </div> -->
                <div v-if="shengchan" :class="type == 2 ? 'active' : 'none'" @click="type = 2">
                  <div>生产信息</div>
                </div>
              </div>
              <div class="dialoginfo-info">
                <!-- 销售信息 -->
                <div v-show="type === 0">
                  <el-form ref="projectForm" :model="projectForm" label-width="120px" label-position="right"
                    hide-required-asterisk>
                    <div class="form-title">
                      <div>基本工程信息</div>
                    </div>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">交底类型</span>
                          <el-select v-model="projectForm.discloseType" placeholder="请选择">
                            <el-option label="委托交底" :value="1"></el-option>
                            <el-option label="合同交底" :value="2"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.discloseType && projectForm.discloseType !== projectForm.discloseType"
                            effect="dark" :content="['', '委托交底', '合同交底'][projectForm.oldFormData.discloseType]"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">工程名称</span>
                          <el-input v-model="projectForm.enginnerrName"></el-input>
                          <el-tooltip
                            v-if="projectForm.enginnerrName && projectForm.enginnerrName !== projectForm.enginnerrName"
                            effect="dark" :content="projectForm.oldFormData.enginnerrName" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item prop="enginnerrNatureId">
                          <span slot="label" style="color: #ff0000">工程性质</span>
                          <el-select ref="enginnerrNature" v-model="projectForm.enginnerrNatureId" placeholder="请选择"
                            @change="getLabel('enginnerrNature')">
                            <el-option v-for="(item, index) in enginnerrNatureIdList" :key="index" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.enginnerrNature && projectForm.enginnerrNature !== projectForm.enginnerrNature"
                            effect="dark" :content="projectForm.oldFormData.enginnerrNature" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">工程地址</span>
                          <el-input v-model="projectForm.enginnerrAddress"></el-input>
                          <el-tooltip
                            v-if="projectForm.enginnerrAddress && projectForm.enginnerrAddress !== projectForm.enginnerrAddress"
                            effect="dark" :content="projectForm.oldFormData.enginnerrAddress" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">行政区</span>
                          <el-cascader ref="administratively" v-model="projectForm.administrativeDistrictsId0"
                            style="width: 432px" :options="treeData" filterable
                            @change="getAdministratively"></el-cascader>
                        </el-form-item>
                      </el-col>
                      <el-col v-show="projectForm.discloseType == 1" :span="12" >
                        <el-form-item prop="delegationTypeId">
                          <span slot="label" style="color: #ff0000">委托类型</span> 
                          <el-select ref="delegationType" v-model="projectForm.delegationTypeId" placeholder="请选择"  disabled  @change="getLabel('delegationType')">
                            <el-option v-for="(item, index) in delegationTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <!-- <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">往来协作</span>
                          <el-select :key="projectForm.collaborationType" v-model="projectForm.collaborationType" placeholder="请选择">
                            <el-option label="非往来协作" :value="1"></el-option>
                            <el-option label="外协" :value="2"></el-option>
                            <el-option label="协外" :value="3"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col> -->
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">合同签订主体</span>
                          <el-select ref="collaborationUnitName" v-model="projectForm.collaborationUnit" placeholder="请选择"
                            @change="getLabel('collaborationUnitName')">
                            <el-option v-for="item in roadWorkList2" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label-width="150px">
                          <span slot="label" style="color: #ff0000">工程现场特性描述</span>
                          <el-input v-model="projectForm.enginnerrLiveDescription"></el-input>
                          <el-tooltip
                            v-if="projectForm.enginnerrLiveDescription && projectForm.enginnerrLiveDescription !== projectForm.enginnerrLiveDescription"
                            effect="dark" :content="projectForm.oldFormData.enginnerrLiveDescription" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label-width="150px">
                          <span slot="label" style="color: #ff0000">是否主工程</span>
                          <el-radio-group v-model="projectForm.isMainEngineering">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label-width="150px">
                          <span slot="label" style="color: #ff0000">是否贸易</span>
                          <el-radio-group v-model="projectForm.wetherTrade">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label-width="150px">
                          <span slot="label" style="color: #ff0000">合同单位类型</span>
                          <el-select v-model="projectForm.roadworkType" placeholder="请选择" clearable>
                            <el-option :key="1" label="建设单位" :value="1"></el-option>
                            <el-option :key="2" label="施工单位" :value="2"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="施工单位">
                          <span slot="label" style="color: #ff0000">施工单位</span>
                          <el-select ref="constructionCompanyId" v-model="projectForm.constructionCompanyId"
                            placeholder="请选择" filterable clearable @change="
                              $nextTick(() => {
                                projectForm.constructionCompany = $refs.constructionCompanyId.selectedLabel;
                              })
                              ">
                            <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="建设单位">
                          <span slot="label" style="color: #ff0000">建设单位</span>
                          <el-select ref="constructionUnitId" v-model="projectForm.constructionUnitId" placeholder="请选择"
                            filterable clearable @change="
                              $nextTick(() => {
                                projectForm.constructionUnit = $refs.constructionUnitId.selectedLabel;
                              })
                              ">
                            <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="小票打印单位">
                          <span slot="label" :style="projectForm.roadworkType == 3 ? 'color: #ff0000' : ''">小票打印单位</span>
                          <el-select ref="otherUnitId" v-model="projectForm.otherUnitId" placeholder="请选择" filterable
                            clearable @change="
                              $nextTick(() => {
                                projectForm.otherUnit = $refs.otherUnitId.selectedLabel;
                              })
                              ">
                            <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="委托单位">
                          <span slot="label" style="color: #ff0000">委托单位</span>
                          <el-input v-model="projectForm.contractCompany"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">内外标识</span>
                          <el-radio-group v-model="projectForm.sidesFlag" @change="handleFlagChange()">
                            <el-radio :label="1">内</el-radio>
                            <el-radio :label="2">外</el-radio>
                          </el-radio-group>
                          <!-- <el-tooltip
                            v-if="projectForm.sidesFlagType && projectForm.sidesFlagType !== projectForm.sidesFlagType"
                            effect="dark" :content="['', '中央企业', '地方国企', '民营企业','地方政府','其他'][projectForm.oldFormData.sidesFlagType]"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip> -->
                        </el-form-item>
                      </el-col>
                      <el-col v-if="projectForm.sidesFlag == 1" :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">所属分公司</span>
                          <el-select ref="affiliatedBranchId" v-model="projectForm.affiliatedBranchId" filterable
                            placeholder="请选择" @change="
                              $nextTick(() => {
                                projectForm.affiliatedBranch = $refs.affiliatedBranchId.selectedLabel;
                              })
                              ">
                            <el-option v-for="item in ExternalSubsidiariesList" :key="item.id" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">企业性质</span>
                          <el-select ref="businessNature" v-model="projectForm.businessNatureId" filterable
                            placeholder="请选择" @change="
                              $nextTick(() => {
                                projectForm.businessNature = $refs.businessNature.selectedLabel;
                              })
                              ">
                            <el-option v-for="item in BusinessNatureList" :key="item.id" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">协调主体</span>
                          <!-- <el-input v-model="projectForm.coordinateName"></el-input> -->
                          <el-select ref="coordinateNameId" v-model="projectForm.coordinateNameId" filterable
                            placeholder="请选择" @change="
                              $nextTick(() => {
                                projectForm.coordinateName = $refs.coordinateNameId.selectedLabel;
                              })
                              ">
                            <el-option v-for="item in coordination" :key="item.id" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">联营标识</span>
                          <el-select v-model="projectForm.poolFlag" placeholder="请选择">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                          </el-select>
                          <el-tooltip v-if="projectForm.poolFlag && projectForm.poolFlag !== projectForm.poolFlag"
                            effect="dark" :content="['否', '是'][projectForm.oldFormData.poolFlag]" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">协调主体（建材）</span>
                          <!-- <el-input v-model="projectForm.coordinateName"></el-input> -->
                          <el-select ref="coordinationSubjectId" v-model="projectForm.coordinationSubjectId" filterable
                            placeholder="请选择" @change="
                              $nextTick(() => {
                                projectForm.coordinationSubject = $refs.coordinationSubjectId.selectedLabel;
                              })
                              ">
                            <el-option v-for="item in JCCoordinationBodyList" :key="item.id" :label="item.itemName"
                              :value="item.id"></el-option>
                            <el-option v-if="showBackupLabel" :value="projectForm.coordinationSubjectId" :label="projectForm.coordinationSubject" disabled />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-show="projectForm.discloseType == 1">
                      <el-col :span="12">
                        <el-form-item label="委托期">
                          <span slot="label" style="color: #ff0000">委托期</span>
                          <el-date-picker v-model="projectForm.entrustBeginTImeEntrustEndTime" style="width: 390px"
                            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :disabled="taskType != 1 && projectForm.discloseType == 1"
                            value-format="yyyy-MM-dd">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="委托量">
                          <span slot="label" style="color: #ff0000">委托量</span>
                          <el-input v-model="projectForm.entrusNumber" :disabled="taskType != 1 && projectForm.discloseType == 1"><template slot="append">方</template></el-input>
                          <el-tooltip
                            v-if="projectForm.entrusNumber && projectForm.entrusNumber !== projectForm.entrusNumber"
                            effect="dark" :content="projectForm.oldFormData.entrusNumber" placement="top-end" >
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">合同号</span>
                          <el-input v-model="projectForm.contractNo"></el-input>
                          <el-tooltip v-if="projectForm.contractNo && projectForm.contractNo !== projectForm.contractNo"
                            effect="dark" :content="projectForm.oldFormData.contractNo" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="施工工期">
                          <span slot="label" style="color: #ff0000">施工工期</span>
                          <el-date-picker v-model="projectForm.constructionStartDateConstructionEndDate"
                            style="width: 390px" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">质监备案号</span>
                          <el-input v-model="projectForm.qiRecord"></el-input>
                          <el-tooltip v-if="projectForm.qiRecord && projectForm.qiRecord !== projectForm.qiRecord"
                            effect="dark" :content="projectForm.oldFormData.qiRecord" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">登记时间</span>
                          <el-date-picker v-model="projectForm.registerTime" value-format="yyyy-MM-dd"
                            placeholder="选择日期时间"> </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <!-- <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">合同单位</span>
                          <el-select ref="businesName" v-model="projectForm.businesNameId" placeholder="请选择">
                            <el-option v-for="item in roadWorkList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.businesName && projectForm.businesName !== projectForm.businesName"
                            effect="dark" :content="projectForm.oldFormData.businesName" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col> -->
                    </el-row>
                    <el-row>
                      <el-col v-show="projectForm.discloseType == 2" :span="12">
                        <el-form-item label="合同总量">
                          <span slot="label" style="color: #ff0000">合同总量</span>
                          <el-input v-model="projectForm.contractSumNumber"
                            @blur="projectForm.contractSumNumber = $regExp.blurCheckNum(projectForm.contractSumNumber) || ''"><template
                              slot="append">方</template></el-input>
                          <el-tooltip
                            v-if="projectForm.contractSumNumber && projectForm.contractSumNumber !== projectForm.contractSumNumber"
                            effect="dark" :content="projectForm.oldFormData.contractSumNumber" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="合同含税总价">
                          <span slot="label" style="color: #ff0000">合同含税总价</span>
                          <el-input v-model="projectForm.contractPriceOfFax"><template
                              slot="append">元</template></el-input>
                          <el-tooltip
                            v-if="projectForm.contractPriceOfFax && projectForm.contractPriceOfFax !== projectForm.contractPriceOfFax"
                            effect="dark" :content="projectForm.oldFormData.contractPriceOfFax" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-show="projectForm.discloseType == 2">
                      <el-col :span="12">
                        <el-form-item label="超合同供应">
                          <span slot="label" style="color: #ff0000">超合同供应</span>
                          <el-radio-group v-model="projectForm.exceedContractControl">
                            <el-radio :label="0">不允许</el-radio>
                            <el-radio :label="1">允许</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-show="projectForm.discloseType == 2">
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">合同生效日期</span>
                          <el-date-picker v-model="projectForm.effectiveDate" value-format="yyyy-MM-dd"
                            placeholder="选择日期时间"> </el-date-picker>
                          <!-- <el-date-picker v-model="projectForm.effectiveDate" type="month" value-format="yyyy-MM" placeholder="选择日期时间" style="width: 390px"> </el-date-picker> -->
                          <el-tooltip
                            v-if="projectForm.effectiveDate && projectForm.effectiveDate !== projectForm.effectiveDate"
                            effect="dark" :content="projectForm.oldFormData.effectiveDate" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">合同有效期</span>
                          <el-date-picker v-model="projectForm.firstIndateEndIndate" style="width: 390px"
                            type="monthrange" range-separator="至" start-placeholder="开始日期" value-format="yyyy-MM"
                            end-placeholder="结束日期"
                            @change="(projectForm.firstIndate = projectForm.firstIndateEndIndate[0] || ''), (projectForm.endIndate = projectForm.firstIndateEndIndate[1] || '')">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">合同模式</span>
                          <el-select :key="projectForm.modelOfContract" v-model="projectForm.modelOfContract"
                            placeholder="请选择">
                            <el-option label="包干" :value="1"></el-option>
                            <el-option label="代工" :value="2"></el-option>
                            <el-option label="其他" :value="3"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.modelOfContract && projectForm.modelOfContract !== projectForm.modelOfContract"
                            effect="dark" :content="['', '包干', '代工', '其他'][projectForm.oldFormData.modelOfContract]"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">结构类型</span>
                          <el-select ref="structuralTypeId" v-model="projectForm.structuralTypeId" placeholder="请选择"
                            filterable clearable @change="
                              $nextTick(() => {
                                projectForm.structuralTypeName = $refs.structuralTypeId.selectedLabel;
                              })
                              ">
                            <el-option v-for="(item, index) in structuralTypeList" :key="index" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">预算员</span>
                          <el-select ref="budgetPerson" v-model="projectForm.budgetPersonId" placeholder="请选择"
                            @change="choseBudget">
                            <el-option v-for="(item, k) in budgetPersonIdList" :key="k" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.budgetPerson && projectForm.budgetPerson !== projectForm.budgetPerson"
                            effect="dark" :content="projectForm.oldFormData.budgetPerson" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">销售员</span>
                          <el-select ref="saller" v-model="projectForm.sallerId" placeholder="请选择">
                            <el-option v-for="(item, k) in sallerIdList" :key="k" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip v-if="projectForm.saller && projectForm.saller !== projectForm.saller" effect="dark"
                            :content="projectForm.oldFormData.saller" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="销售员处别">
                          <span slot="label" style="color: #ff0000">销售员处别</span>
                          <el-select ref="placeType" v-model="projectForm.placeTypeId" placeholder="请选择">
                            <el-option v-for="(item, index) in placeTypeList" :key="index" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip v-if="projectForm.placeType && projectForm.placeType !== projectForm.placeType"
                            effect="dark" :content="projectForm.oldFormData.placeType" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label-width="160px">
                          <span slot="label" style="color: #ff0000">甲方项目负责人及权限</span>
                          <el-input v-model="projectForm.firstLeader"></el-input>
                          <el-tooltip
                            v-if="projectForm.firstLeader && projectForm.firstLeader !== projectForm.firstLeader"
                            effect="dark" :content="projectForm.oldFormData.firstLeader" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">我司合同签字人</span>
                          <el-select v-model="projectForm.ourCompanyCheckPersonId" placeholder="请选择">
                            <el-option v-for="(item, index) in ourCompanyCheckPersonIdList" :key="index"
                              :label="item.name" :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.ourCompanyCheckPerson && projectForm.ourCompanyCheckPerson !== projectForm.ourCompanyCheckPerson"
                            effect="dark" :content="projectForm.oldFormData.ourCompanyCheckPerson" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="甲方有权对量">
                          <span slot="label" style="color: #ff0000">甲方有权对量</span>
                          <el-input v-model="projectForm.richAmount"></el-input>
                          <el-tooltip v-if="projectForm.richAmount && projectForm.richAmount !== projectForm.richAmount"
                            effect="dark" :content="projectForm.oldFormData.richAmount" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">甲方小票签收人</span>
                          <!-- <el-select v-model="projectForm.firstPartySigner" placeholder="请选择" @change="(e)=>{this.projectForm.firstPartySignerId = e;}">
                            <el-option v-for="(item, index) in firstPartySignerIdList" :key="index" :label="item.name" :value="item.id"></el-option>
                          </el-select> -->
                          <el-input v-model.trim="projectForm.firstPartySigner" placeholder="请输入"></el-input>
                          <el-tooltip
                            v-if="projectForm.firstPartySigner && projectForm.firstPartySigner !== projectForm.firstPartySigner"
                            effect="dark" :content="projectForm.oldFormData.firstPartySigner" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">甲方指定邮箱</span>
                          <el-input v-model="projectForm.firstPartyMailbox"></el-input>
                          <el-tooltip
                            v-if="projectForm.firstPartyMailbox && projectForm.firstPartyMailbox !== projectForm.firstPartyMailbox"
                            effect="dark" :content="projectForm.oldFormData.firstPartyMailbox" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">乙方指定邮箱</span>
                          <el-input v-model="projectForm.secondPartyMailbox"></el-input>
                          <el-tooltip
                            v-if="projectForm.secondPartyMailbox && projectForm.secondPartyMailbox !== projectForm.secondPartyMailbox"
                            effect="dark" :content="projectForm.oldFormData.secondPartyMailbox" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="质量约定">
                          <span slot="label" style="color: #ff0000">质量约定</span>
                          <el-select v-model="projectForm.qualityAgreementIds" multiple placeholder="请选择">
                            <el-option v-for="(item, index) in qualityAgreementIdList" :key="index" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.qualityAgreement && projectForm.qualityAgreement !== projectForm.qualityAgreement"
                            effect="dark" :content="projectForm.oldFormData.qualityAgreement" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="收款方式">
                          <span slot="label" style="color: #ff0000">收款方式</span>
                          <el-select v-model="projectForm.clearingForms" multiple>
                            <el-option label="银行现金转账" value="1"></el-option>
                            <el-option label="银行转账汇票" value="2"></el-option>
                            <el-option label="商业转账汇票" value="3"></el-option>
                            <el-option label="供应链金融产品" value="4"></el-option>
                            <el-option label="其他" value="5"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.clearingForms && projectForm.clearingForms !== projectForm.clearingForms"
                            effect="dark"
                            :content="projectForm.oldFormData.clearingForms.map(item => wayList[item]).join(',')"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">发票类别</span>
                          <el-select v-model="projectForm.invoiceCategory" placeholder="请选择">
                            <el-option label="增值税专用发票" :value="1"></el-option>
                            <el-option label="增值税普通发票" :value="2"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">税率</span>
                          <el-select v-model="projectForm.taxRate" placeholder="请选择">
                            <el-option label="3%" :value="1"></el-option>
                            <el-option label="13%" :value="2"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="串换约定">
                          <span slot="label" style="color: #ff0000">串换约定</span>
                          <el-input v-model="projectForm.circulateAgreed" type="textarea"
                            :rows="inputName == '1' && hideText == false ? '3' : '1'" @focus="displayAll('1')"
                            @blur="showSomeText('1')"></el-input>
                          <el-tooltip
                            v-if="projectForm.circulateAgreed && projectForm.circulateAgreed !== projectForm.circulateAgreed"
                            effect="dark" :content="projectForm.oldFormData.circulateAgreed" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="签证约定">
                          <span slot="label" style="color: #ff0000">签证约定</span>
                          <el-input v-model="projectForm.visaAgreed" type="textarea"
                            :rows="inputName == '2' && hideText == false ? '3' : '1'" @focus="displayAll('2')"
                            @blur="showSomeText('2')"></el-input>
                          <el-tooltip v-if="projectForm.visaAgreed && projectForm.visaAgreed !== projectForm.visaAgreed"
                            effect="dark" :content="projectForm.oldFormData.visaAgreed" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="交底备注">
                          <span slot="label" style="color: #ff0000">交底备注</span>
                          <el-input v-model="projectForm.disclosureNotes" type="textarea"
                            :rows="inputName == '3' && hideText == false ? '3' : '1'" @focus="displayAll('3')"
                            @blur="showSomeText('3')"></el-input>
                          <el-tooltip
                            v-if="projectForm.disclosureNotes && projectForm.disclosureNotes !== projectForm.disclosureNotes"
                            effect="dark" :content="projectForm.oldFormData.disclosureNotes" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <div class="form-title">产品信息</div>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">强度等级</span>
                          <el-select v-model="projectForm.strengthGradeArr" multiple placeholder="请选择"
                            @remove-tag="removeTag" @change="$forceUpdate()">
                            <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name"
                              :value="item.id" @click.native="setStrende(item)"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.strengthGrade && projectForm.strengthGrade !== projectForm.strengthGrade"
                            effect="dark"
                            :content="JSON.parse(projectForm.oldFormData.strengthGrade).map(item => item.name)"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="性能等级">
                          <span slot="label" style="color: #ff0000">性能等级</span>
                          <el-select v-model="projectForm.performanceRateArr" multiple placeholder="请选择"
                            @change="$forceUpdate()">
                            <el-option v-for="item in performanceGradeList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.performanceRate && projectForm.performanceRate !== projectForm.performanceRate"
                            effect="dark"
                            :content="JSON.parse(projectForm.oldFormData.performanceRate).map(item => item.name)"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="材料要求">
                          <span slot="label" style="color: #ff0000">材料要求</span>
                          <el-select v-model="projectForm.materialRequirementsArr" multiple placeholder="请选择"
                            @change="$forceUpdate()">
                            <el-option v-for="item in meterialRequirementsList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.materialRequirements && projectForm.materialRequirements !== projectForm.materialRequirements"
                            effect="dark"
                            :content="JSON.parse(projectForm.oldFormData.materialRequirements).map(item => item.name)"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="特殊要求">
                          <span slot="label" style="color: #ff0000">特殊要求</span>
                          <el-select v-model="projectForm.specialRequirementsArr" multiple placeholder="请选择"
                            @change="$forceUpdate()">
                            <el-option v-for="item in specialRequirementsList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.specialRequirements && projectForm.specialRequirements !== projectForm.specialRequirements"
                            effect="dark"
                            :content="JSON.parse(projectForm.oldFormData.specialRequirements).map(item => item.name)"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="其他要求">
                          <span slot="label" style="color: #ff0000">其他要求</span>
                          <el-select v-model="projectForm.otherRequirementsArr" multiple placeholder="请选择"
                            @change="$forceUpdate()">
                            <el-option v-for="item in otherRequirementsList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.otherRequirements && projectForm.otherRequirements !== projectForm.otherRequirements"
                            effect="dark"
                            :content="JSON.parse(projectForm.oldFormData.otherRequirements).map(item => item.name)"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="外加剂要求">
                          <span slot="label" style="color: #ff0000">外加剂要求</span>
                          <el-select v-model="projectForm.admixtureRequirementsArr" multiple placeholder="请选择"
                            @change="$forceUpdate()">
                            <el-option v-for="item in admixtureRequirementsList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.admixtureRequirements && projectForm.admixtureRequirements !== projectForm.admixtureRequirements"
                            effect="dark"
                            :content="JSON.parse(projectForm.oldFormData.admixtureRequirements).map(item => item.name)"
                            placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">浇筑方式</span>
                          <el-select v-model="projectForm.pumpTypeArr" multiple placeholder="请选择"
                            @change="$forceUpdate()">
                            <el-option v-for="item in pumpTypeList" :key="item.id" :label="item.itemName"
                              :value="item.id"></el-option>
                          </el-select>
                          <!-- <el-tooltip
                            v-if="projectForm.pumpType && projectForm.pumpType !== projectForm.pumpType"
                            effect="dark"
                            :content="
                              JSON.parse(projectForm.oldFormData.pumpType)
                                .map(item => item.name)
                                .join(',')
                            "
                            placement="top-end"
                          >
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip> -->
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">小方量约定</span>
                          <el-input v-model="projectForm.smallVolume" type="Number">
                            <template slot="append">方/车</template>
                          </el-input>
                          <el-tooltip
                            v-if="projectForm.smallVolume && projectForm.smallVolume !== projectForm.smallVolume"
                            effect="dark" :content="projectForm.oldFormData.smallVolume" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-for="(items, index) in projectForm.bulkDensities" :id="items.key" :key="items.key">
                      <el-col :span="12">
                        <el-form-item>
                          <span v-if="index == 0" slot="label" style="color: #ff0000">约定容重</span>
                          <el-select v-model="projectForm.bulkDensities[index].strength" placeholder="请选择"
                            style="width: 25%" @change="$forceUpdate()">
                            <el-option v-for="item in projectForm.strengthGradece" :key="item.id" :label="item.name"
                              :value="item.name" @click.native="setId(item, index)"></el-option>
                          </el-select>
                          <el-input v-model="projectForm.bulkDensities[index].bulkDensity" type="number"
                            style="width: 40%"></el-input>
                          <el-link :underline="false" style="margin-left: 20px; color: #018a46" @click="addWeight">添
                            加</el-link>
                          <el-link v-if="index != 0" :underline="false" style="margin-left: 20px; color: #018a46"
                            @click="delWeight(index)">删 除</el-link>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">甲供材料</span>
                          <el-radio-group v-model="projectForm.armorForMaterials">
                            <el-radio :label="0">无</el-radio>
                            <el-radio :label="1">有</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-show="projectForm.discloseType == 1">
                      <el-col :span="24">
                        <el-form-item label-width="220px">
                          <span slot="label" style="color: #ff0000" >需办理委托原因与合同推进情况与预计签订时间简述:</span>
                          <el-input 
                            v-model="projectForm.commissionResume" 
                            placeholder="请输入" 
                            type="textarea" 
                            style="width: 100%" 
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <div v-if="projectForm.armorForMaterials == 1"
                      style="background-color: #f6f8fb; border: 1px dashed #dadada; margin-bottom: 20px; padding-top: 20px; margin-left: 80px">
                      <el-row>
                        <el-col :span="8">
                          <el-form-item label-width="80px">
                            <span slot="label" style="color: #ff0000">供应单位</span>
                            <el-input v-model="projectForm.supplyUnit" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="110px">
                            <span slot="label" style="color: #ff0000">联系人</span>
                            <el-input v-model="projectForm.supplyContacts" style="width: 100%"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="110px">
                            <span slot="label" style="color: #ff0000">联系方式</span>
                            <el-input v-model="projectForm.contactsMode" type="number" style="width: 90%"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                    <!-- <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">约定容重</span>
                          <el-input v-model="projectForm.unitWeight" type="Number"></el-input>
                          <el-tooltip v-if="projectForm.unitWeight&&projectForm.unitWeight!==projectForm.unitWeight" effect="dark" :content="projectForm.oldFormData.unitWeight" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="甲供材料">
                          <span slot="label" style="color: #ff0000">甲供材料</span>
                          <el-radio-group v-model="projectForm.armorForMaterials">
                            <el-radio :label="0">无</el-radio>
                            <el-radio :label="1">有</el-radio>
                          </el-radio-group>
                          <el-tooltip v-if="projectForm.armorForMaterials&&projectForm.armorForMaterials!==projectForm.armorForMaterials" effect="dark" :content="['无','有'][projectForm.oldFormData.armorForMaterials]" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                    </el-row> -->
                    <div v-if="projectForm.armorForMaterials == 1">
                      <div style="padding-bottom: 10px">
                        <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="addItem()">
                          <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                          添加
                        </el-button>
                      </div>
                      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                        border stripe style="width: 100%" :data="projectForm.list" tooltip-effect="dark">
                        <el-table-column label="甲供材料名称" align="center" width="150">
                          <template slot-scope="scope">
                            <span v-if="scope.row.materials" class="table_link" style="cursor: pointer; color: #00b85c"
                              @click="ListChoiceTypeFun(scope.$index, scope.row.materialsId)">{{ scope.row.materials
                              }}</span>
                            <span v-else class="table_link" style="cursor: pointer; color: #00b85c"
                              @click="ListChoiceTypeFun(scope.$index)">选择</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="型号" align="center" prop="specification" width="auto"></el-table-column>
                        <el-table-column label="单方掺量(kg)" align="center">
                          <template slot-scope="scope">
                            <el-input-number v-model="scope.row.mixingAmount" :precision="2" style="width: 100%"
                              :controls="false"></el-input-number>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" align="left" prop="specification" width="100">
                          <template slot-scope="scope">
                            <el-button size="mini" class="bottom_two" @click="deleteItem(scope.$index)">
                              <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                              删除
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div>
                      <div class="form-title">交底附件</div>
                      <div style="padding-left: 50px">
                        <div class="form-title">合同相关文件</div>
                        <FileComponent fileCode="contractFile2" :files="listFilesa1" @deleteFile="deleteFile1"
                          @uplodeSuccess="uplodeSuccess1" />
                      </div>
                    </div>
                    <!-- 领导审批参数（仅审批/查看时且委托交底显示） -->
                    <div v-if="taskType != 1 && projectForm.discloseType == 1" 
                         style="margin-top: 20px; border-top: 1px solid #e1e5ed; padding-top: 20px">
                      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px">
                        <span style="font-size: 18px; font-weight: bold">领导审批参数</span>
                        <el-button 
                          type="primary" 
                          size="medium" 
                          :disabled="leaderConfirmed"
                          @click="leaderConfirmed = true"
                        >
                          {{ leaderConfirmed ? '已确认' : '请确认' }}
                        </el-button>
                      </div>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="本次申请委托时间：">
                            <span slot="label" style="color: #ff0000">本次申请委托时间</span>
                            <el-date-picker
                              v-model="projectForm.entrustBeginTImeEntrustEndTime"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              :disabled="leaderConfirmed"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="本次申请累计委托量（m³）：">
                            <span slot="label" style="color: #ff0000">本次申请累计委托量（m³）</span>
                            <el-input
                              v-model="projectForm.entrusNumber"
                              placeholder="请输入"
                              :disabled="leaderConfirmed"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </el-form>
                </div>
                <!-- 财务信息 -->
                <div v-show="type === 1" style="padding: 0px 130px">
                  <el-form ref="projectForm" :model="projectForm" label-width="120px" label-position="right"
                    hide-required-asterisk :disabled="!caiwuEdit">
                    <div class="form-title">
                      <div>财务信息</div>
                    </div>
                    <div>
                      <el-form-item label-width="120px">
                        <span slot="label">财务编码</span>
                        <el-input v-model="projectForm.financialCode" style="width: 250px"></el-input>
                        <el-tooltip
                          v-if="projectForm.financialCode && projectForm.financialCode !== projectForm.financialCode"
                          effect="dark" :content="projectForm.oldFormData.financialCode" placement="top-end">
                          <i class="el-icon-warning-outline delete-icon"></i>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                  </el-form>
                </div>
                <!-- 生产信息 -->
                <div v-show="type === 2" style="padding: 0px 130px">
                  <el-form ref="projectForm" :model="projectForm" label-width="130px" label-position="right"
                    hide-required-asterisk :disabled="!shengchanEdit">
                    <div class="form-title">
                      <div>生产信息</div>
                    </div>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="建材公司建委号">
                          <span slot="label">建材公司建委号</span>
                          <el-input v-model="projectForm.ccContractNo" style="width: 250px"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="砼工程公司建委号">
                          <span slot="label">砼工程公司建委号</span>
                          <el-input v-model="projectForm.concreteContractNo" style="width: 250px"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">主供应站点</span>
                          <el-select ref="selection1" v-model="projectForm.mainSupplySiteId" style="width: 250px"
                            placeholder="请选择" @change="
                              $nextTick(() => {
                                projectForm.mainSupplySite = $refs.selection1.selectedLabel;
                              }),
                              choiseBussinessPoint(true)
                              ">
                            <el-option v-for="item in pointIdList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                            <el-tooltip
                              v-if="projectForm.mainSupplySite && projectForm.mainSupplySite !== projectForm.mainSupplySite"
                              effect="dark" :content="projectForm.oldFormData.mainSupplySite" placement="top-end">
                              <i class="el-icon-warning-outline delete-icon"></i>
                            </el-tooltip>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="辅供应站点">
                          <el-select ref="secondSupplySite" v-model="projectForm.secondSupplySiteId" style="width: 250px"
                            placeholder="请选择">
                            <el-option v-for="item in pointIdList" :key="item.id" :label="item.name"
                              :value="item.id"></el-option>
                          </el-select>
                          <el-tooltip
                            v-if="projectForm.secondSupplySite && projectForm.secondSupplySite !== projectForm.secondSupplySite"
                            effect="dark" :content="projectForm.oldFormData.secondSupplySite" placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <!-- <el-col :span="12">
                        <el-form-item>
                          <span slot="label" style="color: #ff0000">主供应站点距离</span>
                          <el-input v-model="projectForm.mainSupplySiteDistence" type="Number" style="width: 250px"><template slot="append">千米</template></el-input>
                          <el-tooltip
                            v-if="projectForm.mainSupplySiteDistence && projectForm.mainSupplySiteDistence !== projectForm.mainSupplySiteDistence"
                            effect="dark"
                            :content="projectForm.oldFormData.mainSupplySiteDistence"
                            placement="top-end"
                          >
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col> -->
                    </el-row>
                    <el-row>
                      <el-col :span="20">
                        <el-form-item>
                          <span slot="label">增值服务项</span>
                          <span>{{ servicePoint }}</span>
                          <el-tooltip
                            v-if="projectForm.servicePoint && projectForm.servicePoint !== projectForm.servicePoint"
                            effect="dark" :content="JSON.parse(projectForm.oldFormData.servicePoint)
                              .map(item => item.name)
                              .join(',')
                              " placement="top-end">
                            <i class="el-icon-warning-outline delete-icon"></i>
                          </el-tooltip>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-button class="bottom_two" style="margin-left: 25px"
                          @click="choiseBussinessPoint()">更改</el-button>
                      </el-col>
                    </el-row>
                    <el-row>
                      <!-- <el-col :span="12">
                        <el-form-item label="辅供应站点距离">
                          <el-input v-model="projectForm.secondSupplySiteDistence" style="width: 250px"></el-input>
                        </el-form-item>
                      </el-col> -->
                    </el-row>
                  </el-form>
                </div>
              </div>
              <div style="color: #ff0000; font-size: 12px; padding-top: 9px">请确认以上交底信息填写完整！</div>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" 
              :title="title" 
              :showSendVisible="showSendVisible"
              @handleCancel="handleCancel" 
              @sendCode="sendCode" 
              @lastSub="lastSub" 
              @sendProcessManagerId="sendProcessManagerId"
              @sendProcessVersionId="sendProcessVersionId"
              @handleFinish="handleFinish"
              @handleBusiness="handleBusiness" 
              @setElement="setElement" 
              @submitData="submitDataType"
              @resetFlowState="resetFlowState" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
    <!-- 管控业务点 -->
    <el-dialog v-dialogDrag :visible.sync="bussinessVisible" width="60%">
      <span slot="title" class="dialog-title">管控业务点</span>
      <el-checkbox-group v-model="buspointids">
        <template v-for="(item, index) in buspointArr">
          <div :key="index" class="checkbox-bg">
            <el-checkbox :label="item.id">{{ item.itemName }}</el-checkbox>
          </div>
        </template>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="bussinessVisible = false">关 闭</el-button>
        <el-button class="bottom_all" @click="handlePoint">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 列表单选 -->
    <el-dialog v-dialogDrag :visible.sync="ListChoiceType" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择</span>
      <div class="dialogOtherinfo">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="原物料名称：">
            <el-input v-model="ListChoicePaging.name" placeholder="原物料名称"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="ListChoicePaging.typeId" placeholder="类型">
              <el-option v-for="item in typelist" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="ListChoicePagingFun">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="ListChoiceData" tooltip-effect="dark" highlight-current-row
          @row-click="ListChoiceFun">
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="ListChoiceRadio" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="原物料ID" width="auto" align="center"></el-table-column>
          <el-table-column prop="name" label="原物料名称" width="auto" align="center"></el-table-column>
          <el-table-column prop="brand" label="品牌" width="auto" align="center"></el-table-column>
          <el-table-column prop="specification" label="规格" width="auto" align="center"></el-table-column>
          <el-table-column prop="typeName" label="类型" width="auto" align="center"></el-table-column>
          <el-table-column prop="enable" label="状态" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
              <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="ListChoicePaging.page" :page-size="ListChoicePaging.pageSize"
          layout="total, prev, pager, next, jumper" :total="ListChoicePaging.total"
          @current-change="ListChoicePagingFun(true)"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="ListChoiceType = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="ListChoiceAddFun()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import treeData from "@/views/platform/ICPS/basicConfig/address.js";
// import FileComponent from '@/components/File/fileComponent';
import FileComponent from "./fileComponent";
import FlowContent from "@/components/WorkFlow/flowContent";
import FlowHeader from "@/components/WorkFlow/flowHeader";
import { queryProcesses } from "@/api/basicConfig/proflow.js";
import { UpdatePingGu, rawMaterialsQueryPage,validateParameters,saveDiscloseProcess } from "@/api/internetSales/projectClarifi.js";
import { getUserInfo } from "@/utils/auth.js";
import { queryAllByCompanyId, getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
import { getLists } from "@/api/smart/schedul/c.js";
import { getDicType, getListByTypeId, getDicsType, getStationByCompanyId } from "@/api/common.js";
import { get_simple_user_listBycompanyId } from "@/api/GHnumber/contract";
import { saveOrUpdateDisclose } from "@/api/internetSales/projectClarifi.js";
import { get_detail, getDisClostDetail, getManagement } from "@/api/internetSales/projectClarifi.js";
export default {
  components: {
    FlowContent,
    FileComponent,
    FlowHeader,
  },
  data() {
    return {
      leaderConfirmed: false,           // 领导是否已确认
      inputName: "",
      hideText: "",
      ListChoiceType: false,
      ListChoicePaging: {
        //单选表格分页
        pageSize: 5,
        page: 1,
        total: 0,
        name: "",
        typeId: "",
      },
      typelist: [],
      ListChoiceData: [],
      // bulkDensitiesDel:[],//删除容重
      treeData,
      type: 0,
      executePhase: "",
      title: "工程交底审核",
      billCode: "",
      billDate: "",
      applyPerson: "",
      taskTypeText: ["发起", "已保存", "审批中", "已完成", "撤销", "不通过"],
      taskType: 1,
      taskStatus: "",
      readOnly: false,
      showSendVisible: false,
      projectForm: {
        oldFormData: {},
        // 基础信息
        engineeringId: "",
        discloseType: "",
        enginnerrName: "",
        enginnerrNature: "",
        enginnerrNatureId: "",
        clearingForms: [],
        enginnerrAddress: "",
        administrativeDistrictsId: "",
        administrativeDistrictsId0: "",
        administrativeDistrictsName: "",
        poolFlag: "",
        sidesFlagType: "",
        sidesFlag: 1,
        coordinateName: "",
        coordinateNameId: "",
        enginnerrLiveDescription: "",
        isMainEngineering: "",
        constructionCompany: "",
        contractCompanyId: "",
        contractCompany: "",
        bulkDensities: [
          {
            strength: "",
            strengthId: "",
            bulkDensity: "",
          },
        ], //容重
        commissionResume: "", //供应单位
        supplyUnit: "", //供应单位
        supplyContacts: "", //联系人
        contactsMode: "", //联系方式
        entrustBeginTImeEntrustEndTime: [],
        entrustBeginTime: "",
        entrustEndTime: "",
        entrusNumber: "",
        contractNo: "",
        exceedContractControl: 0, // 超合同供应 (0关闭 1开启)
        constructionStartDateConstructionEndDate: [],
        constructionStartDate: "",
        constructionEndDate: "",
        qiRecord: "",
        firstIndateEndIndate: [],
        firstIndate: "",
        endIndate: "",
        modelOfContract: "",
        budgetPersonId: "",
        budgetPerson: "",
        budgetPersonDepartmentId: "",
        saller: "",
        sallerId: "",
        placeType: "",
        placeTypeId: "",
        servicePoint: [],
        firstLeader: "",
        ourCompanyCheckPerson: "",
        ourCompanyCheckPersonId: "",
        richAmount: "",
        firstPartySigner: "",
        firstPartySignerId: "",
        firstPartyMailbox: "",
        secondPartyMailbox: "",
        qualityAgreement: "",
        qualityAgreementId: "",
        qualityAgreementIds: [],
        clearingForm: "",
        clearingFormId: "",
        ticketAgree: "",
        circulateAgreed: "",
        invoiceCategory: "",
        taxRate: "",
        VisaAgreed: "",
        disclosureNotes: "",
        strengthGrade: "", //强度等级
        strengthGradeArr: [], //强度等级
        performanceRate: "", //性能等级
        performanceRateArr: [], //性能等级
        materialRequirements: "", //材料要求
        materialRequirementsArr: [], //材料要求
        specialRequirements: "", //特殊要求
        specialRequirementsArr: [], //特殊要求
        otherRequirements: "", //其他要求
        otherRequirementsArr: [], //其他要求
        admixtureRequirements: "", //外加剂要求
        admixtureRequirementsArr: [], //外加剂要求
        pumpType: "", //泵送方式
        pumpTypeArr: [], //泵送方式
        smallVolume: "",
        unitWeight: "",
        armorForMaterials: 0,
        financialCode: "",
        ccContractNo: "",
        concreteContractNo: "",
        mainSupplySiteId: "",
        mainSupplySite: "",
        mainSupplySiteDistence: "",
        secondSupplySite: "",
        secondSupplySiteId: "",
        secondSupplySiteDistence: "",
        list: [], //甲供材料列表
        fileFist: [], //附件
        collaborationType: 1,
        collaborationUnit: "",
        coordinationSubject: "",
        coordinationSubjectId: "",
      },
      ourCompanyCheckPersonIdList: [], //公司人员
      budgetPersonIdList: [], //预算员
      sallerIdList: [], //销售员
      firstPartySignerIdList: [], //用料签收员
      qualityAgreementIdList: [], //质量约定
      listFilesa1: [],
      listFilesa2: [], //type 0 1都有
      disAddCosts: [],
      strengthGradeList: [], //强度list
      performanceGradeList: [], //性能等级list
      meterialRequirementsList: [], //材料要求list
      specialRequirementsList: [], //特殊要求list
      otherRequirementsList: [], // 其他要求list
      admixtureRequirementsList: [], //外加剂要求list
      pumpTypeList: [], //浇筑方式泵机类型
      enginnerrNatureIdList: [], //工程性质
      delegationTypeList: [], //委托类型
      placeTypeList: [], //处别
      contractTypeIdList: [], //合同类型
      pointIdList: [], //主供应站点
      roadWorkList: [], //合同单位
      roadWorkList2: [], //往来协作公司
      positionList: [], // 岗位列表
      servicePoint: "",
      bussinessVisible: false,
      buspointArr: [],
      buspointids: [],
      caiwu: false,
      jiaodifile: false,
      caiwuEdit: false,
      shengchanEdit: false,
      shengchan: false,
      companyId: "",
      company: "",
      isFinalSubmission: false,
      wayList: ["", "银行现金转账", "银行转账汇票", "商业转账汇票", "供应链金融产品", "其他"],
      coordination: [],
      structuralTypeList: [],
      ExternalSubsidiariesList: [],
      BusinessNatureList: [],
      JCCoordinationBodyList: [],
      processManagerId: '',
      processVersionId: '',
      processTaskId: '',
    };
  },
  watch: {
    "projectForm.enginnerrName": function () {
      this.title = this.projectForm.enginnerrName ? this.projectForm.enginnerrName + "-工程交底审核" : "工程交底审核";
    },
     // 新增：监听委托时间范围选择器的变化，同步更新开始和结束时间字段
    "projectForm.entrustBeginTImeEntrustEndTime": {
      handler(newVal) {
        if (newVal && newVal.length === 2) {
          this.projectForm.entrustBeginTime = newVal[0];
          this.projectForm.entrustEndTime = newVal[1];
        } else {
          this.projectForm.entrustBeginTime = '';
          this.projectForm.entrustEndTime = '';
        }
      },
      deep: true // 确保能检测到数组内部的变化
    }
  },
  async created() {
    this.treeData.forEach(v => {
      v.children.forEach(res => {
        res.children.forEach(res2 => {
          delete res2.children;
        });
      });
    });
    // 类型
    await getDicType({ code: "MATtype" }).then(res => {
      this.typelist = res.data.items;
    });
    // 结构类型
    getDicType({ code: "structuralType" }).then(res => {
      this.structuralTypeList = res.data.items;
    });
    // 委托类型
    getDicType({ code: "delegation_type" }).then(res => {
      this.delegationTypeList = res.data.items;
    });
    // 分公司
    getDicType({ code: "ExternalSubsidiaries" }).then(res => {
      this.ExternalSubsidiariesList = res.data.items;
    });
    // 企业性质
    getDicType({ code: "BusinessNature" }).then(res => {
      this.BusinessNatureList = res.data.items;
    });
    // 协调单位建材
    getDicType({ code: "JCCoordinationBody" }).then(res => {
      this.JCCoordinationBodyList = res.data.items;
    });
    /**质量约定list */
    await getDicType({ code: "TheQualityAgreement" }).then(res => {
      if (res.data) {
        this.qualityAgreementIdList = res.data.items;
        this.qualityAgreementIdList.map(res => (res.name = res.itemName));
      }
    });
    /* 获取浇筑方式 */
    /**浇筑方式泵机类型 */
    getDicType({
      code: "castingType",
    }).then(res => {
      res.data.items.map(v1 => (v1.type = 1));
      this.pumpTypeList = res.data.items;
      getDicType({
        code: "pouringMethod",
      }).then(res2 => {
        res2.data.items.map(v2 => (v2.type = 2));
        this.pumpTypeList = [...this.pumpTypeList, ...res2.data.items];
        console.log(this.pumpTypeList);
      });
    });

    /**
     * @Description: 获取5大参数
     * @Param:
     * @Author: wangwangwang
     */
    await getLists().then(res => {
      res.data.forEach(item => {
        if (!item) return;
        if (item.typeName == "强度等级") {
          this.strengthGradeList = item.list;
        } else if (item.typeName == "规范性能等级") {
          this.performanceGradeList = item.list;
        } else if (item.typeName == "材料要求") {
          this.meterialRequirementsList = item.list;
        } else if (item.typeName == "特殊要求") {
          this.specialRequirementsList = item.list;
        } else if (item.typeName == "外加剂要求") {
          this.admixtureRequirementsList = item.list;
        } else if (item.typeName == "其他要求") {
          this.otherRequirementsList = item.list;
        }
      });
    });
    /**
     * @Description: 获取强度等级
     * @Param:
     * @Author: wangwangwang
     */
    await getListByTypeId({
      typeId: 1,
    }).then(res => {
      this.arr1 = res.data;
    });
    /**
     * @Description: 获取数据字典
     * @Param:
     * @Author: wangwangwang
     */
    await getDicsType({ codes: "EngineeringNature,contractType,MATname,castingType,shutdownLogo, placeDon, recordFixedPostition, market" }).then(res => {
      if (res.code === 1001) {
        this.enginnerrNatureIdList = res.data.EngineeringNature.items;
        this.contractTypeIdList = res.data.contractType.items;
        this.arr2 = res.data.MATname.items;
        this.shutdownLogoList = res.data.shutdownLogo.items;
        this.placeTypeList = res.data.placeDon.items;
        this.fixPosition = res.data.recordFixedPostition.items;
        this.buspointArr = res.data.market.items;
      }
    });
    /**
     * @Description: 获取施工单位
     * @Param:
     * @Author: wangwangwang
     */
    await queryAllByCompanyId().then(res => {
      if (res.code === 1001) {
        this.roadWorkList = res.data;
      }
    });
    await getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.roadWorkList2 = res.data;
      }
    });
    await this.get_detail();
  },
  computed: {
  // 判断当前选中的值在字典里是否存在
  isValueInDict() {
    return this.JCCoordinationBodyList.some(item => item.id === this.projectForm.coordinationSubjectId);
  },

  // 是否显示兜底的禁用选项
  showBackupLabel() {
    return this.projectForm.coordinationSubjectId && !this.isValueInDict;
  }
},

  mounted() {
    getDicsType({ codes: "EngineeringNature" }).then(res => {
      if (res.code === 1001) {
        this.enginnerrNatureIdList = res.data.EngineeringNature.items;
      }
    });
    const { query } = this.$route;
    this.taskType = query.type
    if (query.type == 1) {
      // 发起流程
      this.initFlowsData();
      this.applyPerson = getUserInfo().userRealName;
      this.$refs.flowcontent.initBaseData("ProjectClarifiFlow");
      this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      return;
    }
    this.initFlowsData2();
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
  },
  methods: {
    handleFlagChange() {
      this.projectForm.affiliatedBranchId = '';
      this.projectForm.affiliatedBranch='';
        if(this.projectForm.sidesFlag == 1) {
          this.projectForm.coordinationSubject = ""
          this.projectForm.coordinationSubjectId = ""
        }
        if(this.projectForm.sidesFlag == 2) {
          if(this.projectForm.roadworkType == 1){
            this.projectForm.coordinationSubject = this.projectForm.constructionUnit 
            this.projectForm.coordinationSubjectId = this.projectForm.constructionUnitId
          }
          if(this.projectForm.roadworkType == 2){
            this.projectForm.coordinationSubject = this.projectForm. constructionCompany 
            this.projectForm.coordinationSubjectId = this.projectForm.constructionCompanyId
          }
        }
      },
    get_detail() {
      get_detail({ id: "328726135586295808" }).then(res => {
        this.coordination = res.data.items;
      });
    },
    //添加容重
    addWeight() {
      this.projectForm.bulkDensities.push({
        bulkDensity: "",
        strength: "",
        strengthId: "",
        type: 1, //添加1 修改2 删除0
      });
    },
    delWeight(index) {
      //   var removeBulk =  this.projectForm.bulkDensities.splice(index, 1);
      // if (removeBulk[0].id) {
      //   removeBulk[0].type = 0;
      //   this.bulkDensitiesDel.push(removeBulk[0]);
      // }
      this.projectForm.bulkDensities.splice(index, 1);
    },
    removeTag(item) {
      this.projectForm.strengthGradece.forEach((m, n) => {
        if (item == m.id) {
          this.projectForm.strengthGradece.splice(n, 1);
        }
      });
      this.projectForm.bulkDensities.forEach((items, index) => {
        if (item == items.strengthId) {
          this.delWeight(index);
          console.log(this.projectForm.bulkDensities);
          if (this.projectForm.bulkDensities.length == 0) {
            this.projectForm.bulkDensities = [
              {
                bulkDensity: "",
                strength: "",
                strengthId: "",
                type: 1, //添加1 修改2 删除0
              },
            ];
          }
          this.$forceUpdate();
        }
      });
    },
    setId(item, index) {
      if (!this.projectForm.bulkDensities[index].id) {
        this.projectForm.bulkDensities[index].type = 1;
      } else {
        this.projectForm.bulkDensities[index].type = 2;
      }
      this.projectForm.bulkDensities[index].strengthId = item.id;
    },
    setStrende(item) {
      this.projectForm.strengthGradece.push(item);
      this.$forceUpdate();
    },
    // 隐藏部分内容
    showSomeText(str) {
      if (str == "1") {
        this.inputName = null;
        this.hideText = true;
      } else if (str == "2") {
        this.inputName = null;
        this.hideText = true;
      } else if (str == "3") {
        this.inputName = null;
        this.hideText = true;
      }
    },
    // 显示所有内容
    displayAll(str) {
      if (str == "1") {
        this.inputName = "1";
        this.hideText = false;
      } else if (str == "2") {
        this.inputName = "2";
        this.hideText = false;
      }
      if (str == "3") {
        this.inputName = "3";
        this.hideText = false;
      }
      console.log(this.$refs.circulateAgreedInput.$attrs.rows);
    },
    // 预算员选择
    choseBudget(e) {
      for (let i = 0; i < this.budgetPersonIdList.length; i++) {
        if (this.budgetPersonIdList[i].id === e) {
          this.projectForm.budgetPerson = this.budgetPersonIdList[i].name;
        }
      }
      // console.log(this.budgetPersonIdList.some(budgetPerson=>{budgetPerson.id==e }));
    },
    /**保存和校验不重复选中项 */
    ListChoiceAddFun() {
      //原物料选择后对应值【品牌，规格..】带入表格中
      this.projectForm.list[this.ListChoiceDataIndex].materialsId = this.ListChoiceRadioRow.id;
      this.projectForm.list[this.ListChoiceDataIndex].materials = this.ListChoiceRadioRow.name;
      this.projectForm.list[this.ListChoiceDataIndex].specification = this.ListChoiceRadioRow.specification;
      this.ListChoiceType = false;
    },

    // 获取下拉框选中数据的label
    getLabel(key) {
      this.$nextTick(() => {
        this.$set(this.projectForm, key, this.$refs[key].selected.label);
      });
    },
    // 获取行政区具体地址
    getAdministratively() {
      const arr = this.$refs["administratively"].getCheckedNodes()[0].pathLabels;
      this.projectForm.administrativeDistrictsName = JSON.stringify(arr);
    },
    /**
 * 校验委托交底参数
 * true-校验通过, false-校验失败或接口异常
 */
    checkDelegationParams() {
      return new Promise((resolve) => {
        // 确保 delegationType 有值
        if (!this.projectForm.delegationType && this.projectForm.delegationTypeId) {
          const selected = this.delegationTypeList.find(item => item.id === this.projectForm.delegationTypeId);
          if (selected) {
            this.projectForm.delegationType = selected.itemName;
          }
        }

        // 构建请求参数
        const params = {
          entrusNumber: this.projectForm.entrusNumber,
          entrustBeginTime: this.projectForm.entrustBeginTime,
          entrustEndTime: this.projectForm.entrustEndTime,
          delegationTypeId: this.projectForm.delegationTypeId,
          delegationType: this.projectForm.delegationType,
          engineeringId: this.projectForm.engineeringId
        };

        // 调用校验接口
        validateParameters(params).then(res => {
          if (res.code === 1001) {
            if (res.data.resultJudgment === '1001') {
              resolve(true);
            } else {
              this.$message.warning(res.data.resultMsg);
              resolve(false);
            }
          } 
        })
      });
    },
    /**验证 */
    chackForm() {
      if (!this.projectForm.discloseType) {
        this.$message.warning("交底类型不能为空");
        return;
      } else if (!this.projectForm.enginnerrName) {
        this.$message.warning("工程名称不能为空");
        return;
      } else if (!this.projectForm.enginnerrNatureId) {
        this.$message.warning("工程性质不能为空");
        return;
      } else if (!this.projectForm.enginnerrAddress) {
        this.$message.warning("工程地址不能为空");
        return;
      } else if (!this.projectForm.administrativeDistrictsId0 || !this.projectForm.administrativeDistrictsId0.length) {
        this.$message.warning("行政区不能为空");
        return;
      } else if (this.projectForm.poolFlag === "") {
        this.$message.warning("联营标识不能为空");
        return;
      } else if (this.projectForm.sidesFlag == 1 && !this.projectForm.affiliatedBranchId) {
        this.$message.warning("所属分公司不能为空");
        return;
      } else if (!this.projectForm.businessNatureId) {
        this.$message.warning("企业性质不能为空");
        return;
      } else if (!this.projectForm.coordinateNameId) {
        this.$message.warning("协调主体不能为空");
        return;
      } else if (!this.projectForm.coordinationSubjectId) {
        this.$message.warning("协调主体(建材)不能为空");
        return;
      } else if (!this.projectForm.collaborationUnit) {
        this.$message.warning("合同签订主体不能为空");
        return;
      } else if (!this.projectForm.businesNameId) {
        this.$message.warning("合同单位不能为空");
        return;
      } else if (!this.projectForm.effectiveDate && this.projectForm.discloseType == 2) {
        this.$message.warning("合同生效日期不能为空");
        return;
      } else if (!this.projectForm.firstIndateEndIndate?.length && this.projectForm.discloseType == 2) {
        this.$message.warning("合同有效期不能为空");
        return;
      } else if (!this.projectForm.modelOfContract) {
        this.$message.warning("合同模式不能为空");
        return;
      } else if (!this.projectForm.budgetPersonId) {
        this.$message.warning("预算员不能为空");
        return;
      } else if (!this.projectForm.commissionResume && this.projectForm.discloseType == 1) {
        this.$message.warning("需办理委托原因与合同推进情况与预计签订时间简述不能为空");
        return false;
      }else if (!this.projectForm.sallerId) {
        this.$message.warning("销售员不能为空");
        return;
      } else if (!this.projectForm.firstLeader) {
        this.$message.warning("甲方项目负责人及权限不能为空");
        return;
      } else if (!this.projectForm.ourCompanyCheckPersonId) {
        this.$message.warning("我司合同签字人不能为空");
        return;
      } else if (!this.projectForm.firstPartySigner) {
        this.$message.warning("甲方小票签收人不能为空");
        return;
      } else if (this.projectForm.strengthGradeArr?.length == 0) {
        this.$message.warning("强度等级不能为空");
        return;
      } else if (!this.projectForm.qualityAgreementIds?.length) {
        this.$message.warning("质量约定不能为空");
        return;
      } else if (this.projectForm.pumpTypeArr?.length == 0) {
        this.$message.warning("泵送方式不能为空");
        return;
      } else if (!this.projectForm.enginnerrLiveDescription) {
        this.$message.warning("工程现场特性描述不能为空");
        return;
      } else if (!this.projectForm.isMainEngineering && this.projectForm.isMainEngineering !== 0) {
        this.$message.warning("是否主工程不能为空");
        return;
      } else if (!this.projectForm.wetherTrade && this.projectForm.wetherTrade !== 0) {
        this.$message.warning("是否贸易不能为空");
        return;
      } else if (this.projectForm.entrustBeginTImeEntrustEndTime?.length !== 2 && this.projectForm.discloseType == 1) {
        this.$message.warning("委托期不能为空");
        return;
      } else if (!this.projectForm.entrusNumber && this.projectForm.discloseType == 1) {
        this.$message.warning("委托量不能为空");
        return;
      } else if (!this.projectForm.placeTypeId) {
        this.$message.warning("销售处别不能为空");
        return;
      }
      // if (!this.projectForm.buseftPlaceTypeId) {
      //   this.$message.warning('预算处别不能为空');
      //   return
      // } else
      else if (!this.projectForm.armorForMaterials && this.projectForm.armorForMaterials !== 0) {
        this.$message.warning("请选择甲供材料");
        return;
      } else if (!this.projectForm.invoiceCategory) {
        this.$message.warning("发票类别不能为空");
        return;
      } else if (!this.projectForm.taxRate) {
        this.$message.warning("税率不能为空");
        return;
      } else if (!this.projectForm.roadworkType) {
        this.$message.warning("合同单位类型不能为空");
        return;
      } else if (!this.projectForm.constructionCompany) {
        this.$message.warning("施工单位不能为空");
        return;
      } else if (!this.projectForm.constructionUnitId) {
        this.$message.warning("建设单位不能为空");
        return;
      } else if (this.projectForm.roadworkType == 3 && !this.projectForm.otherUnit) {
        this.$message.warning("其他单位不能为空");
        return;
      } else if (!this.projectForm.contractCompany) {
        this.$message.warning("委托单位不能为空");
        return;
      } else if (!this.projectForm.contractNo) {
        this.$message.warning("合同号不能为空");
        return;
      } else if (!this.projectForm.constructionStartDateConstructionEndDate?.length) {
        this.$message.warning("施工工期不能为空");
        return;
      } else if (!this.projectForm.qiRecord) {
        this.$message.warning("质监备案号不能为空");
        return;
      } else if (!this.projectForm.contractSumNumber && this.projectForm.discloseType == 2) {
        this.$message.warning("合同总量不能为空");
        return;
      } else if (!this.projectForm.contractPriceOfFax) {
        this.$message.warning("合同含税总价不能为空");
        return;
        // } else if (!this.projectForm.buseftPlaceTypeId) {
        //   this.$message.warning('预算员处别不能为空');
        //   return
      } else if (!this.projectForm.richAmount) {
        this.$message.warning("甲方有权对量不能为空");
        return;
      } else if (!this.projectForm.firstPartyMailbox) {
        this.$message.warning("甲方指定邮箱不能为空");
        return;
      } else if (!this.projectForm.secondPartyMailbox) {
        this.$message.warning("乙方指定邮箱不能为空");
        return;
      } else if (!this.projectForm.qualityAgreementIds) {
        this.$message.warning("质量约定不能为空");
        return;
      } else if (!this.projectForm.clearingForms?.length) {
        this.$message.warning("收款方式不能为空");
        return;
      } else if (!this.projectForm.circulateAgreed) {
        this.$message.warning("串换约定不能为空");
        return;
      } else if (!this.projectForm.visaAgreed) {
        this.$message.warning("签证约定不能为空");
        return;
      } else if (!this.projectForm.disclosureNotes) {
        this.$message.warning("交底备注不能为空");
        return;
      } else if (!this.projectForm.performanceRateArr?.length) {
        this.$message.warning("性能等级不能为空");
        return;
      } else if (!this.projectForm.materialRequirementsArr?.length) {
        this.$message.warning("材料要求不能为空");
        return;
      } else if (!this.projectForm.specialRequirementsArr?.length) {
        this.$message.warning("特殊要求不能为空");
        return;
      } else if (!this.projectForm.otherRequirementsArr?.length) {
        this.$message.warning("其他要求不能为空");
        return;
      } else if (!this.projectForm.admixtureRequirementsArr?.length) {
        this.$message.warning("外加剂要求不能为空");
        return;
      } else if (!this.projectForm.smallVolume.toString().trim()) {
        this.$message.warning("小方量约定不能为空");
        return;
      } else if (!this.projectForm.bulkDensities?.length) {
        this.$message.warning("约定容重不能为空");
        return;
      }
      // else if (!this.projectForm.ccContractNo && this.ButtonList.findIndex(res => (res.buttonValue == 'SCXX')) !== -1) {
      //   this.$message.warning('建材公司建委合同号不能为空');
      //   return
      // } else if (!this.projectForm.mainSupplySiteId && this.ButtonList.findIndex(res => (res.buttonValue == 'SCXX')) !== -1) {
      //   this.$message.warning('主供应站点不能为空');
      //   return
      // } else if (!this.projectForm.mainSupplySiteDistence && this.ButtonList.findIndex(res => (res.buttonValue == 'SCXX')) !== -1) {
      //   this.$message.warning('主供应站点距离不能为空');
      //   return
      // }
      return true;
    },
    async saveBaseInfo(type, isShowSubmit, pass) {
      if (!this.chackForm()) {
        return false;
      }
      /**
       * 保存基本交底信息
       * @param  {[type]} params1).then(( [description]
       * @return {[type]}                 [description]
       */
      // this.projectForm.fileFist = this.listFilesa1;
      if (this.listFilesa2 && this.listFilesa1) {
        this.projectForm.fileFist = [...this.listFilesa2, ...this.listFilesa1];
      }
      this.projectForm.strengthGrade = JSON.stringify(
        this.projectForm.strengthGradeArr?.map(v => {
          let obj = { id: v, name: this.strengthGradeList.find(v2 => v2.id == v)?.name };
          return obj;
        })
      );
      this.projectForm.performanceRate = JSON.stringify(
        this.projectForm.performanceRateArr?.map(v => {
          let obj = { id: v, name: this.performanceGradeList.find(v2 => v2.id == v)?.name };
          return obj;
        })
      );
      this.projectForm.materialRequirements = JSON.stringify(
        this.projectForm.materialRequirementsArr?.map(v => {
          let obj = { id: v, name: this.meterialRequirementsList.find(v2 => v2.id == v)?.name };
          return obj;
        })
      );
      this.projectForm.specialRequirements = JSON.stringify(
        this.projectForm.specialRequirementsArr?.map(v => {
          let obj = { id: v, name: this.specialRequirementsList.find(v2 => v2.id == v)?.name };
          return obj;
        })
      );
      this.projectForm.otherRequirements = JSON.stringify(
        this.projectForm.otherRequirementsArr?.map(v => {
          let obj = { id: v, name: this.otherRequirementsList.find(v2 => v2.id == v)?.name };
          return obj;
        })
      );
      this.projectForm.admixtureRequirements = JSON.stringify(
        this.projectForm.admixtureRequirementsArr?.map(v => {
          let obj = { id: v, name: this.admixtureRequirementsList.find(v2 => v2.id == v)?.name };
          return obj;
        })
      );
      if (this.projectForm.pumpTypeArr.length > 0) {
        this.projectForm.pumpType = JSON.stringify(
          this.projectForm.pumpTypeArr.map(v => {
            let obj = { id: v, name: this.pumpTypeList.find(v2 => v2.id == v)?.itemName, type: this.pumpTypeList.find(v2 => v2.id == v)?.type };
            return obj;
          })
        );
      } else {
        this.projectForm.pumpType = "";
      }
      console.log(this.projectForm.pumpType);
      if (this.projectForm.clearingForms?.length > 0) {
        this.projectForm.clearingForm = this.projectForm.clearingForms.join(",");
      } else {
        this.projectForm.clearingForm = "";
      }
      if (this.projectForm.qualityAgreementIds?.length > 0) {
        this.projectForm.qualityAgreementId = this.projectForm.qualityAgreementIds.join(",");
      } else {
        this.projectForm.qualityAgreementId = "";
      }
      if (this.projectForm.entrustBeginTime) {
        this.projectForm.entrustBeginTImeEntrustEndTime = [this.projectForm.entrustBeginTime, this.projectForm.entrustEndTime];
      }
      if (this.projectForm.constructionStartDate) {
        this.projectForm.constructionStartDateConstructionEndDate = [this.projectForm.constructionStartDate, this.projectForm.constructionEndDate];
      }
      this.projectForm.firstIndateEndIndate = [this.projectForm.firstIndate, this.projectForm.endIndate];
      if (this.projectForm.effectiveDate) {
        this.projectForm.effectiveDate = this.projectForm.effectiveDate.toString().length <= 7 ? this.projectForm.effectiveDate.toString() + "-01 00:00:00" : this.projectForm.effectiveDate.toString();
      }
      // this.projectForm.bulkDensities = [...this.bulkDensitiesDel, ...this.projectForm.bulkDensities];
      console.log(this.projectForm.list);
      // saveOrUpdateDisclose(this.projectForm).then(res => {
      //   console.log(res)
      // })
      if (pass) {
        this.projectForm.wetherApproved = 1;
      }
      await saveOrUpdateDisclose(this.projectForm).then(res => {
        console.log(res);
        this.getDetail();
        if (type === 2 && isShowSubmit) {
          this.showSendVisible = true;
          setTimeout(() => {
          let approvalOptions = '本次申请委托时间:' + (this.projectForm.entrustBeginTImeEntrustEndTime[0]+'至'+this.projectForm.entrustBeginTImeEntrustEndTime[1] + ', 本次申请累计委托量（m³）:' + this.projectForm.entrusNumber)
          this.$refs.flowcontent.setOperationModal(approvalOptions)
        }, 200)
        }
      });
    },
    /**
     * @Description: 选择管控业务点
     * @Param: 通过选中的站点获取默认选中数据
     * @Author: wangwangwang
     */
    choiseBussinessPoint(type) {
      if (!this.projectForm.mainSupplySiteId && !type) {
        this.$message.warning("请选择主供应站点后再进行操作");
        return;
      }
      if (!type) {
        this.bussinessVisible = true;
      }
      // this.bussinessVisible = true;

      // if (this.projectForm?.servicePoint) {
      //   const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
      //   const copyData = newData.filter(item => item.type * 1 === 1);
      //   this.buspointids = copyData.map(item => item.id);
      // } else {
        if (this.projectForm?.mainSupplySiteId) {
          queryProcesses({ stationId: this.projectForm?.mainSupplySiteId }).then(res => {
            if (res.code === 1001) {
              const newData = res.data.servicePoint ? JSON.parse(res.data.servicePoint) : [];
              const copyData = newData.filter(item => item.type * 1 === 1);
              this.buspointids = copyData.map(item => item.id);
              this.servicePoint = copyData.map(item => item.name).join("、");
              this.projectForm.servicePoint = JSON.stringify(copyData.map(item => ({ id: item.id, name: item.name, type: 1 })));
            }
          });
        }
      // }
      // 原来的增值服务项
      // if (this.projectForm?.servicePoint) {
      //   const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
      //   const copyData = newData.filter(item => item.type * 1 === 1);
      //   this.buspointids = copyData.map(item => item.id);
      // } else {
      //   if (this.projectForm?.mainSupplySiteId) {
      //     queryProcesses({ stationId: this.projectForm?.mainSupplySiteId }).then(res => {
      //       if (res.code === 1001) {
      //         const newData = res.data.servicePoint ? JSON.parse(res.data.servicePoint) : [];
      //         const copyData = newData.filter(item => item.type * 1 === 1);
      //         this.buspointids = copyData.map(item => item.id);
      //         this.servicePoint = copyData.map(item => item.name).join("、");
      //         this.projectForm.servicePoint = JSON.stringify(copyData.map(item => ({ id: item.id, name: item.name, type: 1 })));
      //       }
      //     });
      //   }
      // }
    },
    handlePoint() {
      const newData = this.buspointArr.filter(item => this.buspointids.some(items => item.id === items));
      this.servicePoint = newData.map(item => item.itemName).join(",");
      this.projectForm.servicePoint = JSON.stringify(newData.map(item => ({ id: item.id, name: item.itemName, type: 1 })));
      this.bussinessVisible = false;
    },
    /**原物料单选列表查询 */
    ListChoicePagingFun() {
      rawMaterialsQueryPage(this.ListChoicePaging).then(res => {
        this.ListChoiceData = res.data.data;
        this.ListChoicePaging.total = res.data.totalRows;
      });
    },
    /**单选列表打开 */
    ListChoiceTypeFun(index, id) {
      this.ListChoiceType = true;
      this.ListChoiceDataIndex = index;
      if (id) {
        this.ListChoiceRadio = id;
        this.ListChoiceRadioCopy = id;
      } else {
        this.ListChoiceRadio = "";
        this.ListChoiceRadioCopy = "";
      }
      this.ListChoicePagingFun();
    },
    //单选选中
    ListChoiceFun(currentRow) {
      if (currentRow) {
        let type = this.projectForm.list.findIndex(res => res.materialsId == currentRow.id);
        if (type == -1 || this.ListChoiceRadioCopy == currentRow.id) {
          this.ListChoiceRadio = currentRow.id;
          this.ListChoiceRadioRow = currentRow;
        } else {
          this.$message({
            message: "该选项已被选择！",
            type: "warning",
          });
          setTimeout(() => {
            this.ListChoiceRadioRow = "";
          }, 100);
        }
      }
    },
    /*表单*/
    addItem() {
      let data = {
        materialsId: "",
        materials: "",
        specification: "",
        mixingAmount: "0",
      };
      this.projectForm.list.push(data);
    },
    deleteFile1(index) {
      var removeFile = this.listFilesa1.splice(index, 1);
      removeFile[0].type = 0;
      this.listFilesa2.push(removeFile[0]);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess1(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.listFilesa1.push(params);
    },
    // administrativeDistrictsIdFun(value, label, extra) {
    //   this.projectForm.administrativeDistrictsId = JSON.stringify([extra.triggerNode.$parent.$parent.$options.propsData.value, extra.triggerNode.$parent.$options.propsData.value, value])
    //   this.$forceUpdate()
    // },
    handleBusiness() {
      // this.projectForm.fileFist = this.listFilesa1;
      if (this.listFilesa2 && this.listFilesa1) {
        this.projectForm.fileFist = [...this.listFilesa2, ...this.listFilesa1];
      }
      if (this.projectForm.strengthGradeArr.length > 0) {
        this.projectForm.strengthGrade = JSON.stringify(
          this.projectForm.strengthGradeArr.map(v => {
            let obj = { id: v, name: this.strengthGradeList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      }
      if (this.projectForm.performanceRateArr.length > 0) {
        this.projectForm.performanceRate = JSON.stringify(
          this.projectForm.performanceRateArr.map(v => {
            let obj = { id: v, name: this.performanceGradeList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.performanceRate = "";
      }
      if (this.projectForm.materialRequirementsArr.length > 0) {
        this.projectForm.materialRequirements = JSON.stringify(
          this.projectForm.materialRequirementsArr.map(v => {
            let obj = { id: v, name: this.meterialRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.materialRequirements = "";
      }
      if (this.projectForm.specialRequirementsArr.length > 0) {
        this.projectForm.specialRequirements = JSON.stringify(
          this.projectForm.specialRequirementsArr.map(v => {
            let obj = { id: v, name: this.specialRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.specialRequirements = "";
      }
      if (this.projectForm.otherRequirementsArr.length > 0) {
        this.projectForm.otherRequirements = JSON.stringify(
          this.projectForm.otherRequirementsArr.map(v => {
            let obj = { id: v, name: this.otherRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.otherRequirements = "";
      }
      if (this.projectForm.admixtureRequirementsArr.length > 0) {
        this.projectForm.admixtureRequirements = JSON.stringify(
          this.projectForm.admixtureRequirementsArr.map(v => {
            let obj = { id: v, name: this.admixtureRequirementsList.find(v2 => v2.id == v)?.name };
            return obj;
          })
        );
      } else {
        this.projectForm.admixtureRequirements = "";
      }
      if (this.projectForm.pumpTypeArr.length > 0) {
        this.projectForm.pumpType = JSON.stringify(
          this.projectForm.pumpTypeArr.map(v => {
            let obj = { id: v, name: this.pumpTypeList.find(v2 => v2.id == v)?.itemName, type: this.pumpTypeList.find(v2 => v2.id == v)?.type };
            return obj;
          })
        );
      } else {
        this.projectForm.pumpType = "";
      }
      this.projectForm.companyId = this.companyId;
      this.projectForm.company = this.company;
      if (this.projectForm.clearingForms?.length > 0) {
        this.projectForm.clearingForm = this.projectForm.clearingForms.join(",");
      } else {
        this.projectForm.clearingForm = "";
      }
      if (this.projectForm.qualityAgreementIds?.length > 0) {
        this.projectForm.qualityAgreementId = this.projectForm.qualityAgreementIds.join(",");
      } else {
        this.projectForm.qualityAgreementId = "";
      }
      if (this.projectForm.entrustBeginTime) {
        this.projectForm.entrustBeginTImeEntrustEndTime = [this.projectForm.entrustBeginTime, this.projectForm.entrustEndTime];
      }
      if (this.projectForm.constructionStartDate) {
        this.projectForm.constructionStartDateConstructionEndDate = [this.projectForm.constructionStartDate, this.projectForm.constructionEndDate];
      }
      this.projectForm.firstIndateEndIndate = [this.projectForm.firstIndate, this.projectForm.endIndate];
      if (this.projectForm.effectiveDate) {
        this.projectForm.effectiveDate = this.projectForm.effectiveDate.toString().length <= 7 ? this.projectForm.effectiveDate.toString() + "-01 00:00:00" : this.projectForm.effectiveDate.toString();
      }

      /**
       * 当页面参数没有时，通过表单数据补充
       */
      if (!this.executePhase) {
        switch (this.projectForm.discloseType * 1) {
          case 1:
            this.executePhase = 1;
            break;
          case 2:
            this.executePhase = 4;
            break;
          default:
            break;
        }
      }

      if (this.executePhase) {
        const params = {
          process_success: {
            // url: '/icps/system/sign/cloudSell/disclose/saveOrUpdateDisclose',
            url: "/icps/system/sign/cloudSell/disclose/updateEngineeringDisclose",
            // data: {...this.projectForm, statusNum: 4},
            data: {
              // engineeringId: this.projectForm.engineeringId,
              ...this.projectForm,
              statusNum: 4,
              statusType: this.executePhase,
            },
            httpMethod: "post",
          },
          process_failure: {
            url: "/icps/system/sign/cloudSell/disclose/updateEngineeringDisclose",
            data: {
              engineeringId: this.projectForm.engineeringId,
              statusNum: 3,
              statusType: this.executePhase,
            },
            httpMethod: "post",
          },
        };
        console.log(this.executePhase);

        this.showSendVisible = false;
        this.$refs.flowcontent.handleToFlow(params);
      } else {
        this.$message.warning("未获取到交底类型");
        return;
      }
    },
    /* 
      判断是否是最后一个节点提交审核
    */
    lastSub(e) {
      console.log(e);
      this.isFinalSubmission = e;
    },
    sendProcessManagerId(processManagerId) {
      this.processManagerId = processManagerId
    },
    sendProcessVersionId(processVersionId) {
      console.log(processVersionId)
      this.processVersionId = processVersionId
      console.log('processVersionId----------------------' + processVersionId)
    },
    /**
     * @Description:
     * @Param: 1为保存，2为最后提交
     * @Author: wangwangwang
     * @param {*} type
     */
    //第一次提交更新状态，审批通过更新状态,其余不管
    handleFinish(type, status) {
      if (type === 1) {
        UpdatePingGu({
          engineeringId: this.projectForm.engineeringId,
          statusNum: 2,
          statusType: this.executePhase,
        });
        saveDiscloseProcess({
          engineeringId: this.projectForm.engineeringId,
              processManagerId: this.processManagerId,
              processTaskId: status,
              processVersionId: this.processVersionId,
              receiptNumber: this.billCode
        });
      }
      if (status === 3) {
        UpdatePingGu({
          engineeringId: this.projectForm.engineeringId,
          statusNum: 3,
          statusType: this.executePhase,
        });
      }
    },
    /**
     * type 1保存，2提交，3撤回，4抄送，5交办，6回退，7协审，8加减签，9流程图，10收藏任务
     */
    async handleSubmit(type) {
      if (!this.chackForm()) {
        return false;
      }
      if (this.taskType != 1 && !this.leaderConfirmed && type == 2 && this.projectForm.discloseType == 1 ) {
        this.$message.warning('请确认领导审批参数!')
        return
      }
      this.projectForm.list = this.projectForm.list.map(item => ({
        materials: item.materials,
        materialsId: item.materialsId,
        mixingAmount: item.mixingAmount,
        specification: item.specification,
      }));
       if (type == 2 && this.projectForm.discloseType == 1 && this.leaderConfirmed) {
          const isPass = await this.checkDelegationParams();
          if (!isPass) {
            return; // 校验不通过，终止提交
          }
        }
      const { query } = this.$route;
      const data = {
        dataSource: "ProjectClarifiFlow",
        dataContent: JSON.stringify({ formData: this.projectForm, fileList1: this.listFilesa1, companyId: this.companyId, company: this.company, executePhase: this.executePhase }), // 业务数据
      };
      let isRet = false;
      switch (type) {
        case 1:
          console.log(this.listFilesa1);
          window.sessionStorage.setItem("form", JSON.stringify(this.projectForm));
          window.sessionStorage.setItem("file", JSON.stringify(this.listFilesa1));
          // window.sessionStorage.setItem('file', JSON.stringify([...this.listFilesa2,...this.listFilesa1]))
          break;
        case 2: {
          if (query.type * 1 === 2 && query.taskType * 1 !== 2) {
            if (!this.projectForm.mainSupplySiteId && this.shengchan) {
              this.$message.warning("生产信息存在必填数据未填写");
              isRet = false;
              return;
            } else {
              if (this.caiwu || this.shengchan) {
                this.$refs.flowcontent.saveFlows(1, data, true);
              }
              isRet = true;
            }
          }
          break;
        }
        case 3: {
          let curData = {
            engineeringId: this.projectForm.engineeringId,
            statusNum: 5,
            statusType: this.executePhase,
          };
          this.$refs.flowcontent.saveFlows(3, curData);
          this.initFlowsData();
          isRet = true;
          break;
        }
        default:
          break;
      }
      this.saveBaseInfo(type, query.type * 1 === 2 && query.taskType * 1 !== 2 && isRet);
      // this.getDetail();
      if (!isRet) {
        this.$refs.flowcontent.saveFlows(type, data);
        this.initFlowsData();
      }

      // this.saveBaseInfo();
      // if(type === 1) {
      //   window.sessionStorage.setItem('form', JSON.stringify(this.projectForm))
      //   window.sessionStorage.setItem('file', JSON.stringify(this.listFilesa1))
      // }
      // const { query } = this.$route;
      // const data = {
      //   dataSource: "ProjectClarifiFlow",
      //   dataContent: JSON.stringify({formData: this.projectForm, fileList1: this.listFilesa1, companyId: this.companyId, company: this.company, executePhase: this.executePhase}), // 业务数据
      // };
      // if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) {
      //   // 财务审批
      //   // if (!this.projectForm.financialCode && this.caiwu) {
      //   //   this.$message.warning('财务编码不能为空');
      //   //   return
      //   // }
      //   if ((!this.projectForm.mainSupplySiteId || !this.projectForm.mainSupplySiteDistence) && this.shengchan) {
      //     this.$message.warning('生产信息存在必填数据未填写');
      //     return
      //   }
      //   if (this.caiwu) {
      //     this.saveBaseInfo();
      //     this.$refs.flowcontent.saveFlows(1, data, true);
      //   }
      //   if (this.shengchan) {
      //     this.saveBaseInfo()
      //     this.$refs.flowcontent.saveFlows(1, data, true);
      //   }
      //   this.showSendVisible = true;
      //   return;
      // }
      // if(type === 3) {
      //   const data = {
      //     engineeringId: this.projectForm.engineeringId,
      //     statusNum: 5,
      //     statusType: this.executePhase,
      //   }
      //   this.$refs.flowcontent.saveFlows(3, data);
      //   this.initFlowsData()
      //   return
      // }
      // this.$refs.flowcontent.saveFlows(type, data);
      // this.initFlowsData()
    },
    submitDataType() {
      UpdatePingGu({
        engineeringId: this.projectForm.engineeringId,
        statusNum: 2,
        statusType: this.executePhase,
        secondaryStatus: 1,
      });
    },
    resetFlowState(type) {
      let _this = this
      UpdatePingGu({
        engineeringId: this.projectForm.engineeringId,
        statusNum: type === 1 ? 3 : 5,
        statusType: _this.executePhase,
        secondaryStatus: 1,
      });
      const params = {
        engineeringId: this.projectForm.engineeringId,
        statusNum: type === 1 ? 3 : 5,
        statusType: _this.executePhase,
        secondaryStatus: 1,
      };
      this.$refs.flowcontent.handleToFlow(params);
      this.showSendVisible = false;
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode();
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 处理审批要素
     * @param {*}
     * @Author: wangwangwang
     */
    setElement(data) {
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].code === "caiwu" && data[i].hideType === "1") {
          this.caiwu = true;
        }
        if (data[i].code === "jiaodifile" && data[i].hideType === "1") {
          this.jiaodifile = true;
        }
        if (data[i].code === "shengchan" && data[i].hideType === "1") {
          this.shengchan = true;
        }
        if (data[i].code === "caiwu" && data[i].readonly) {
          this.caiwuEdit = true;
        }
        if (data[i].code === "shengchan" && data[i].readonly) {
          this.shengchanEdit = true;
        }
      }
    },
    /**
     * @Description: 回显业务数据
     * @Param:
     * @Author: wangwangwang
     */
    initFlowsData() {
      this.isReadOnly = true;
      const { query } = this.$route;
      console.log("initFlowsData2", query);
      const { formData, fileList1, companyId, company, executePhase } = query;
      // this.listFilesa1 = JSON.parse(fileList1);
      // this.projectForm = JSON.parse(formData);
      this.companyId = companyId;
      this.company = company;
      if (!this.executePhase) {
        this.executePhase = executePhase;
      }

      const form = JSON.parse(window.sessionStorage.getItem("form")) || null;
      const file = JSON.parse(window.sessionStorage.getItem("file")) || null;
      const tempResume = this.projectForm.commissionResume;
      this.projectForm = form ? form : JSON.parse(formData);
      this.projectForm.commissionResume = tempResume || '';
      this.listFilesa1 = file ? file : JSON.parse(fileList1);
      console.log(this.listFilesa1);
      console.log(file);
      console.log(JSON.parse(fileList1));
      this.title = this.projectForm.enginnerrName ? this.projectForm.enginnerrName + "-工程交底审核" : "工程交底审核";
      /*根据公司获取站点*/
      getStationByCompanyId({ id: companyId }).then(res => {
        this.pointIdList = res.data.map(v => {
          return {
            id: v.stationId,
            name: v.stationName,
          };
        });
      });
      /*我司合同签字人*/
      get_simple_user_listBycompanyId({
        roleId: "7605679267385344",
        orgznizationId: companyId,
      }).then(res => {
        this.ourCompanyCheckPersonIdList = res.data;
      });
      /*获取预算员*/
      get_simple_user_listBycompanyId({
        roleId: "48d84b503be7484ca1b5c2eade1ff004",
        orgznizationId: companyId,
      }).then(res => {
        this.budgetPersonIdList = res.data;
      });
      /*获取销售员*/
      get_simple_user_listBycompanyId({
        roleId: "12b2f6ff304148fd89141e9faa9afb96",
        orgznizationId: companyId,
      }).then(res => {
        this.sallerIdList = res.data;
      });
      /*获取用料签收员*/
      get_simple_user_listBycompanyId({
        roleId: "3e32ac0a1e95449d91d80bd97bd30ec7",
      }).then(res => {
        this.firstPartySignerIdList = res.data;
      });
      const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
      const copyData = newData.filter(item => item.type == 1);
      this.servicePoint = copyData.map(item => item.name).join(",");
      if (!this.servicePoint) {
        this.choiseBussinessPoint(true);
      }
      console.log("query.engineeringId", this.projectForm.engineeringId);
      this.getDetail();
    },
    initFlowsData2() {
      const { query } = this.$route;
      console.log("initFlowsData2", query);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
      const data = JSON.parse(query.dataContent);
      this.projectForm.engineeringId = data.formData.engineeringId;
      const { formData, fileList1, companyId, company, executePhase } = data;
      // this.listFilesa1 = fileList1;
      // this.projectForm = formData
      this.companyId = companyId || formData.companyId;
      this.company = company || formData.company;
      // console.log(this.executePhase, executePhase, data)
      console.log(data);

      this.executePhase = formData.executePhase ? formData.executePhase : executePhase;
      const form = JSON.parse(window.sessionStorage.getItem("form")) || null;
      const file = JSON.parse(window.sessionStorage.getItem("file")) || null;
      this.projectForm = form ? form : formData;
      this.listFilesa1 = file ? file : fileList1;
      this.title = this.projectForm.enginnerrName ? this.projectForm.enginnerrName + "-工程交底审核" : "工程交底审核";

      console.log("===========this.projectForm===========");
      console.log(this.projectForm);
      /*根据公司获取站点*/
      getStationByCompanyId({ id: this.companyId }).then(res => {
        this.pointIdList = res.data.map(v => {
          return {
            id: v.stationId,
            name: v.stationName,
          };
        });
      });
      /*我司合同签字人*/
      get_simple_user_listBycompanyId({
        roleId: "7605679267385344",
        orgznizationId: this.companyId,
      }).then(res => {
        this.ourCompanyCheckPersonIdList = res.data;
      });
      /*获取预算员*/
      get_simple_user_listBycompanyId({
        roleId: "48d84b503be7484ca1b5c2eade1ff004",
        orgznizationId: this.companyId,
      }).then(res => {
        this.budgetPersonIdList = res.data;
      });
      /*获取销售员*/
      get_simple_user_listBycompanyId({
        roleId: "12b2f6ff304148fd89141e9faa9afb96",
        orgznizationId: this.companyId,
      }).then(res => {
        this.sallerIdList = res.data;
      });
      /*获取用料签收员*/
      get_simple_user_listBycompanyId({
        roleId: "3e32ac0a1e95449d91d80bd97bd30ec7",
      }).then(res => {
        this.firstPartySignerIdList = res.data;
      });
      const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
      const copyData = newData.filter(item => item.type == 1);
      this.servicePoint = copyData.map(item => item.name).join(",");
      if (!this.servicePoint) {
        this.choiseBussinessPoint(true);
      }
      console.log("query.engineeringId", this.projectForm.engineeringId);
      this.getDetail();
    },
    sendCode(code) {
      this.billCode = code;
    },
    /**再次编辑或者审核，重新初始化数据页面,查询详情 */
    async getDetail() {
      const id = this.projectForm.engineeringId;
      await getDisClostDetail({ id: id }).then(async res => {
        // alert("!@12")
        if (res.data) {
          this.leaderConfirmed = false
          const tempResume = this.projectForm.commissionResume;
          this.projectForm = { ...this.projectForm, ...res.data };
          this.projectForm.commissionResume = tempResume || '';
          console.log("this.projectForm", this.projectForm);
          if (this.projectForm.administrativeDistrictsId) {
            this.projectForm.administrativeDistrictsId0 = JSON.parse(this.projectForm.administrativeDistrictsId); //行政区
          }
          this.projectForm.strengthGradeArr = JSON.parse(this.projectForm.strengthGrade)?.map(v => v.id); //强度等级
          this.projectForm.strengthGradece = JSON.parse(this.projectForm.strengthGrade);
          // console.log(this.strengthGradece)
          if (this.projectForm.performanceRate) {
            this.projectForm.performanceRateArr = JSON.parse(this.projectForm.performanceRate)?.map(v => v.id); //性能等级
          }
          if (this.projectForm.materialRequirements) {
            this.projectForm.materialRequirementsArr = JSON.parse(this.projectForm.materialRequirements)?.map(v => v.id); //材料要求
          }
          if (this.projectForm.specialRequirements) {
            this.projectForm.specialRequirementsArr = JSON.parse(this.projectForm.specialRequirements)?.map(v => v.id); //特殊要求
          }
          if (this.projectForm.otherRequirements) {
            this.projectForm.otherRequirementsArr = JSON.parse(this.projectForm.otherRequirements)?.map(v => v.id); //其他要求
          }
          if (this.projectForm.admixtureRequirements) {
            this.projectForm.admixtureRequirementsArr = JSON.parse(this.projectForm.admixtureRequirements)?.map(v => v.id); //外加剂要求
          }
          if (res.data.pumpType) {
            let pumpTypeJson = res.data.pumpType;
            console.log(pumpTypeJson);
            // const arr = [];
            // for (let i = 0; i < this.pumpTypeList.length; i++) {
            //   for (let j = 0; j < pumpType.length; j++) {
            //     if (pumpType[j].id === this.pumpTypeList[i].id) {
            //       arr.push(pumpType[j].id);
            //     }
            //   }
            // }
            this.projectForm.pumpTypeArr = JSON.parse(pumpTypeJson)?.map(v => v.id);
            // this.projectForm.pumpTypeArr = JSON.parse(this.projectForm.pumpType) ?.map((v) => v.id)//泵送方式
          }
          if (this.projectForm.entrustBeginTime) {
            this.projectForm.entrustBeginTImeEntrustEndTime = [this.projectForm.entrustBeginTime, this.projectForm.entrustEndTime];
          }
          if (this.projectForm.clearingForm) {
            this.projectForm.clearingForms = this.projectForm.clearingForm.split(",");
          }
          if (this.projectForm.qualityAgreementId) {
            this.projectForm.qualityAgreementIds = this.projectForm.qualityAgreementId.split(",");
          }
          if (this.projectForm.constructionStartDate) {
            this.projectForm.constructionStartDateConstructionEndDate = [this.projectForm.constructionStartDate, this.projectForm.constructionEndDate];
          }
          this.projectForm.firstIndateEndIndate = [this.projectForm.firstIndate, this.projectForm.endIndate];
          this.projectForm.list = res.data.list || [];
          const newData = this.projectForm.servicePoint ? JSON.parse(this.projectForm.servicePoint) : [];
          this.oldFormData = JSON.parse(JSON.stringify(this.projectForm));
          const copyData = newData.filter(item => item.type == 1);
          this.servicePoint = copyData.map(item => item.name).join(",");
          //合同回显组装
          const Arry1 = [];
          for (let i = 0; i < res.data.fileFist?.length; i += 1) {
            if (res.data.fileFist[i].fileType === "1") {
              const data = {
                name: res.data.fileFist[i].fileName,
                fileName: res.data.fileFist[i].fileName,
                fileUrl: res.data.fileFist[i].path,
                path: res.data.fileFist[i].path,
                fileType: 1,
                createTime: res.data.fileFist[i].createTime,
                type: 1,
                id: res.data.fileFist[i].id,
              };
              Arry1.push(data);
            }
          }
          this.listFilesa1 = Arry1;
          if (this.projectForm.bulkDensities.length == 0) {
            this.projectForm.bulkDensities = [{ bulkDensity: "", strength: "", strengthId: "", type: "" }];
          }
          // console.log(this.listFilesa1);
        }
      });
      getManagement({ id: id }).then(res => {
        if (res.data) {
          res.data.validityOfDelegationId *= 1;
          res.data.reportLogoId *= 1;
        }
        this.projectForm.riskInfo = res.data || {};
      });
    },
  },
  beforeDestroy() {
    window.sessionStorage.removeItem("form");
    window.sessionStorage.removeItem("file");
  },
};
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}

.info {
  padding: 0 20px;
  background: #fff;

  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;

    .left {
      @include discen_al;
    }

    .text {
      margin-left: 60px;
    }
  }
}

.nav_title {
  @include discen_al;
  align-items: flex-end;

  >div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }

  i {
    margin-left: 5px;
  }

  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}

.dialoginfo {
  padding: 0;
}

.active {
  border-top: 1px #e1e5ed solid;
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  background: #fff;
}

.dialoginfo-info {
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  border-bottom: 1px #e1e5ed solid;
}

/*弹窗*/
.dialoginfo-title {
  >div {
    cursor: pointer;
    flex: 1;
  }

  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);

  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid #e1e5ed;

    >div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }

  .center {
    width: 1px;
    height: 48px;
    background: #e1e5ed;
  }

  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid rgba(0, 0, 0, 0);

    >div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}

.dialoginfo-info {
  padding: 10px 20px;
  overflow: auto;
  height: calc(85vh - 282px);

  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}

.form-title {
  font-size: 18px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}

.checkbox-bg {
  margin: 0 10px 10px 10px;
  display: inline-block;
}

.delete-icon {
  color: #ffda20;
  font-size: 20px;
  position: absolute;
  right: -20px;
  top: 8px;
  cursor: pointer;
}
</style>